var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lesson-entity"},[_vm._t("header"),(_vm.targetModel)?_c(_vm.targetType,{ref:"entity",tag:"component",attrs:{"entity":_vm.targetModel,"config":_vm.entity.entity_data,"theme":_vm.theme}}):_vm._e(),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }